import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import CityPage from './pages/CityPage'
import GlobalHubPage from './pages/GlobalHubPage'
import SegmentPage from './pages/SegmentPage'
import AffiliateRedirect from './pages/AffiliateRedirect'
import { LocaleProvider, useLocale } from './contexts/LocaleContext'
import { getSegmentPageSlugs, getGlobalHubSlug } from './utils/getSlugs'
import StickyButton from './components/StickyButton'
import Popup from './components/Popup'
import './App.css'

function AppRoutes() {
  const { translations } = useLocale()
  const globalHubSlug = getGlobalHubSlug(translations)
  const segmentPages = getSegmentPageSlugs(translations)

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/anmelden" element={<AffiliateRedirect />} />
      <Route path={`/${globalHubSlug}`} element={<GlobalHubPage />} />
      {segmentPages.map((page) => (
        <Route key={page.slug} path={`/${page.slug}`} element={<SegmentPage />} />
      ))}
      <Route path="/:citySlug" element={<CityPage />} />
    </Routes>
  )
}

function App() {
  return (
    <LocaleProvider>
      <Router>
        <AppRoutes />
        <StickyButton />
        <Popup />
      </Router>
    </LocaleProvider>
  )
}

// Debug: Add function to clear popup sessionStorage (for testing)
if (typeof window !== 'undefined') {
  window.clearPopupSession = () => {
    sessionStorage.removeItem('transdates-popup-shown')
    console.log('Popup session cleared - refresh page to see popup')
  }
}

export default App
